import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import ErrorBoundary from './components/ErrorBoundary';
import SkipLink from './components/SkipLink';
import GlobalStyle from './globalStyles';

// Import pages
import Quiz from './pages/Quiz';
import Results from './pages/Results';
import ResultsPrint from './pages/ResultsPrint';
import PaymentSuccess from './pages/PaymentSuccess';
import PaymentCancelled from './pages/PaymentCancelled';
import CheckIn from './pages/CheckIn';
import ResultsReveal from './pages/ResultsReveal';
import TypesIndex from './pages/TypesIndex';
import TypeProfile from './pages/TypeProfile';
import ScoringLab from './pages/ScoringLab';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import CookiePolicy from './pages/CookiePolicy';
import Contact from './pages/Contact';

import { initPaymentProcessor } from './utils/paymentService';
import { isPaymentsEnabled } from './utils/featureFlags';

function App() {
  useEffect(() => {
    if (isPaymentsEnabled()) {
      initPaymentProcessor();
    }
  }, []);

  // GitHub Pages SPA fallback:
  // 404.html redirects to /?p=/some/route, we restore it here.
  useEffect(() => {
    try {
      const params = new URLSearchParams(window.location.search);
      const redirectedPath = params.get('p');
      if (!redirectedPath) return;
      const nextUrl = `${window.location.origin}${process.env.PUBLIC_URL}${redirectedPath}`;
      window.history.replaceState(null, '', nextUrl);
    } catch (e) {
      // Non blocking
    }
  }, []);

  return (
    <ErrorBoundary>
      <Router>
        <SkipLink />
        <GlobalStyle />
      <Routes>
        <Route path="/" element={<Quiz />} />
        <Route path="/types" element={<TypesIndex />} />
        <Route path="/types/:typeId" element={<TypeProfile />} />
        <Route path="/results/reveal" element={<ResultsReveal />} />
        <Route path="/results" element={<Results />} />
        <Route path="/results/print" element={<ResultsPrint />} />
        <Route path="/check-in" element={<CheckIn />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsOfService />} />
        <Route path="/cookies" element={<CookiePolicy />} />
        <Route path="/contact" element={<Contact />} />
        {process.env.NODE_ENV === 'development' && (
          <Route path="/scoring-lab" element={<ScoringLab />} />
        )}
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/payment/cancelled" element={<PaymentCancelled />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      </Router>
    </ErrorBoundary>
  );
}

export default App;